import React, { type FC } from 'react';
import Image, { type ImageProps as ImageUrlProps } from 'next/image';

export interface LocalImageProps extends ImageUrlProps {
    src: string;
    className?: string;
}

const LocalImage: FC<LocalImageProps> = props => {
    const url = props.src?.startsWith('/')
        ? `${process.env.assetEnv || ''}${props.src}`
        : props.src;

    return (
        <Image
            {...props}
            className={props.className}
            src={url}
            alt={props.alt || 'Grafika'}
        />
    );
};

export default LocalImage;
